"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reactIntl = require("react-intl");

var _Toast = require("@react/react-spectrum/Toast");

var _Icon = _interopRequireDefault(require("@react/react-spectrum/Icon"));

var _TextStrikethrough = _interopRequireDefault(require("@react/react-spectrum/Icon/TextStrikethrough"));

var _AnnotatePen = _interopRequireDefault(require("@react/react-spectrum/Icon/AnnotatePen"));

var _PinOff = _interopRequireDefault(require("@react/react-spectrum/Icon/PinOff"));

var _svgs = require("../lib/svgs");

var _AnnotationsMaskView = _interopRequireDefault(require("../style/AnnotationsMaskView.scss"));

var _constants = require("../constants");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

/**
 * Annotations component
 */
var AnnotationsMask = /*#__PURE__*/function (_React$Component) {
  _inherits(AnnotationsMask, _React$Component);

  var _super = _createSuper(AnnotationsMask);

  /**
   * Constructor for AnnotationsMask
   * @param {object} props - props sent to the component
   * @returns {undefined}
   */
  function AnnotationsMask(props) {
    var _this;

    _classCallCheck(this, AnnotationsMask);

    _this = _super.call(this, props);
    _this.state = {};
    _this.handleMaskClick = _this.handleMaskClick.bind(_assertThisInitialized(_this));
    return _this;
  }
  /**
   * Lifecycle method for when a component has been updated
   * @param {object} previousProps - previous version of the props
   * @returns {undefined}
   */


  _createClass(AnnotationsMask, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(previousProps) {
      var _this2 = this;

      var _this$props = this.props,
          isPlacingAnnotation = _this$props.isPlacingAnnotation,
          compactLayout = _this$props.compactLayout,
          showAnnotationMask = _this$props.showAnnotationMask,
          touchControls = _this$props.touchControls;

      if (isPlacingAnnotation && !previousProps.isPlacingAnnotation && showAnnotationMask && (compactLayout || touchControls)) {
        this.setState({
          overrideHover: true
        });
        this.mobileHoverTimer = setTimeout(function () {
          _this2.setState({
            overrideHover: false
          });
        }, 3000);
      }
    }
    /**
     * Lifecycle method called when component is about to be removed from DOM.
     * @returns {undefined}
     */

  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      clearTimeout(this.mobileHoverTimer);
    }
    /**
     * Click handler for the mask
     * @returns {undefined}
     */

  }, {
    key: "handleMaskClick",
    value: function handleMaskClick() {
      var _this$props2 = this.props,
          setUnmappedView = _this$props2.setUnmappedView,
          viewingUnmapped = _this$props2.viewingUnmapped;

      if (viewingUnmapped) {
        setUnmappedView(false);
      }
    }
    /**
     * Lifecycle method for rendering
     * @returns {ReactElement} markup
     */

  }, {
    key: "render",
    value: function render() {
      var _this$props3 = this.props,
          compactLayout = _this$props3.compactLayout,
          hovered = _this$props3.hovered,
          drawingNode = _this$props3.drawingNode,
          hasAnnotationLocation = _this$props3.hasAnnotationLocation,
          isPlacingAnnotation = _this$props3.isPlacingAnnotation,
          maskTextOverride = _this$props3.maskTextOverride,
          newAnnotationType = _this$props3.newAnnotationType,
          spectrumUIScale = _this$props3.spectrumUIScale,
          style = _this$props3.style,
          theme = _this$props3.theme,
          touchControls = _this$props3.touchControls,
          viewingUnmapped = _this$props3.viewingUnmapped;
      var overrideHover = this.state.overrideHover;
      var isHovered = (compactLayout || touchControls) && !overrideHover || hovered;
      var hintMask;

      if (viewingUnmapped || isPlacingAnnotation && !isHovered && !hasAnnotationLocation && drawingNode === undefined) {
        var maskText;
        var maskSvg;
        var maskClasses = 'hint-mask';

        if (newAnnotationType === 'pin') {
          if (maskTextOverride) {
            maskText = maskTextOverride;
          } else if (compactLayout) {
            maskText = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
              id: "comments.annotations.annotation_hint_mobile"
            });
          } else {
            maskText = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
              id: "comments.annotations.annotation_hint"
            });
          }

          maskSvg = /*#__PURE__*/_react.default.createElement(_PinOff.default, {
            size: "S"
          });
        }

        if (newAnnotationType === 'highlight') {
          if (maskTextOverride) {
            maskText = maskTextOverride;
          } else if (compactLayout) {
            maskText = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
              id: "comments.annotations.annotation_highlight_hint_mobile"
            });
          } else {
            maskText = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
              id: "comments.annotations.annotation_highlight_hint"
            });
          }

          maskSvg = /*#__PURE__*/_react.default.createElement(_Icon.default, {
            size: "S"
          }, _svgs.highlightIcon);
        }

        if (newAnnotationType === 'strikethrough') {
          if (maskTextOverride) {
            maskText = maskTextOverride;
          } else if (compactLayout) {
            maskText = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
              id: "comments.annotations.annotation_strikethrough_hint_mobile"
            });
          } else {
            maskText = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
              id: "comments.annotations.annotation_strikethrough_hint"
            });
          }

          maskSvg = /*#__PURE__*/_react.default.createElement(_TextStrikethrough.default, {
            size: "S"
          });
        }

        if (newAnnotationType === 'insert') {
          if (maskTextOverride) {
            maskText = maskTextOverride;
          } else {
            maskText = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
              id: "comments.annotations.annotation_insert_hint"
            });
          }

          maskSvg = /*#__PURE__*/_react.default.createElement(_Icon.default, {
            size: "S"
          }, _svgs.insertIcon);
        }

        if (newAnnotationType === 'replace') {
          if (maskTextOverride) {
            maskText = maskTextOverride;
          } else {
            maskText = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
              id: "comments.annotations.annotation_replace_hint"
            });
          }

          maskSvg = /*#__PURE__*/_react.default.createElement(_Icon.default, {
            size: "S"
          }, _svgs.replaceIcon);
        }

        if (newAnnotationType === 'draw') {
          if (maskTextOverride) {
            maskText = maskTextOverride;
          } else if (compactLayout) {
            maskText = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
              id: "comments.annotations.annotation_draw_hint_mobile"
            });
          } else {
            maskText = /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
              id: "comments.annotations.annotation_draw_hint"
            });
          }

          maskSvg = /*#__PURE__*/_react.default.createElement(_AnnotatePen.default, {
            size: "S"
          });
        }

        if (viewingUnmapped) {
          maskText = /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, /*#__PURE__*/_react.default.createElement(_Toast.Toast, {
            variant: "info",
            className: "unmapped-toast"
          }, /*#__PURE__*/_react.default.createElement(_reactIntl.FormattedMessage, {
            id: "comments.annotations_mask.viewing_unmapped"
          })));
          maskClasses += ' unmapped';
          maskSvg = null;
        }

        hintMask = /*#__PURE__*/_react.default.createElement("div", {
          className: maskClasses
        }, maskText, maskSvg);
      }

      var wrapperClasses = "".concat(_AnnotationsMaskView.default.component, " ").concat(theme, "-theme ").concat(spectrumUIScale, "-scale");

      if ((isHovered || !isPlacingAnnotation) && !viewingUnmapped) {
        wrapperClasses += ' no-capture-pointer-events';
      }

      var componentStyle = Object.assign({}, style);

      if (compactLayout || touchControls) {
        componentStyle.pointerEvents = 'none';
      }

      return /*#__PURE__*/_react.default.createElement("div", {
        id: _constants.ANNOTATION_MASK_COMPONENT_ID,
        ref: this.handleOverlayRef,
        className: wrapperClasses,
        style: componentStyle,
        onClick: this.handleMaskClick
      }, hintMask);
    }
  }]);

  return AnnotationsMask;
}(_react.default.Component);

exports.default = AnnotationsMask;
AnnotationsMask.defaultProps = {
  spectrumUIScale: 'medium',
  theme: 'light'
};
AnnotationsMask.propTypes = {
  compactLayout: _propTypes.default.bool,
  hasAnnotationLocation: _propTypes.default.bool,
  hovered: _propTypes.default.bool,
  drawingNode: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
  isPlacingAnnotation: _propTypes.default.bool,
  maskTextOverride: _propTypes.default.string,
  newAnnotationType: _propTypes.default.string,
  setUnmappedView: _propTypes.default.func,
  showAnnotationMask: _propTypes.default.bool,
  spectrumUIScale: _propTypes.default.oneOf(['medium', 'large']),
  style: _propTypes.default.object,
  theme: _propTypes.default.oneOf(['light', 'lightest', 'dark', 'darkest']),
  touchControls: _propTypes.default.bool,
  viewingUnmapped: _propTypes.default.bool
};